import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-publish-vessel-dialog',
    templateUrl: './publish-vessel-dialog.component.html',
    styleUrls: ['./publish-vessel-dialog.component.css'],
    standalone: false,
})
export class PublishVesselDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<PublishVesselDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            projectVersion: string;
        }
    ) {}

    cancel() {
        this.dialogRef.close();
    }

    acceptUnlock() {
        this.dialogRef.close(true);
    }
}
